/* RD - Responsable de Diseño -  toma decisión de la(s) propuesta(s) asignadas a su rol */
/* RD.Contenido - Documentar */

//*react- recursos
    import { useState, useEffect, useCallback } from "react";
    import { Panel, PanelGroup } from "rsuite";
    import { useDropzone } from "react-dropzone";
    import swal2 from "sweetalert2"; //npm install --save sweetalert2

//*componentes-utiles
    import CargandoSpin from "../../../../componentes/CargandoSpin";

//*clases 
    import ReactTooltip from "react-tooltip";
    import '../../../../css/mdi.css';
    import { Col, Row } from "react-bootstrap";
    import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; //'libreria' que cita el bote de basura
    import { faTrashAlt } from "@fortawesome/free-solid-svg-icons"; //icono bote de basura  

//*archivos (imagenes y elementos necesarios para la rutina)
    import RDPropuesta from "./RD.Documentar.Propuesta";
    import RDEvidencias from "./RD.Documentar.Evidencias";
    
//*api's (servicios y store)
    import proposalsServicio from "../../../../api/recursos/proposals/proposals.servicio"; 
    import proposalsStore from "../../../../api/recursos/proposals/proposals.store"; 

    import analysisServicio from "../../../../api/recursos/analysis/analysis.servicio"; 
    import analysisStore from "../../../../api/recursos/analysis/analysis.store"; 

    import filesServicio from "../../../../api/recursos/files/files.servicio"; 
    import filesStore from "../../../../api/recursos/files/files.store"; 

    import notificationsServicio from "../../../../api/recursos/notifications/notifications.servicio"; 
    import notificationsStore from "../../../../api/recursos/notifications/notifications.store"; 

//*store's

//*datos
    import etiquetasSSC from "../../../../datos/json/etiquetasSSC.json";
    import articulos from "../../../../datos/json/guidelines.json";
    
//*interfaces
    interface propsRDDocumentar {
        tokenStore: any;
        pfcId: any,
        catDecisiones: any,
        catPruebas: any,
        catPTCaracteristicas: any,
        botonCierraSlidingPanel:any;
        recargaRD: any;
        recargaPaginaSSC: any;
        recargaPaginaSSC_Not:any;
    }

//*componente
 export default function RDDocumentar(props: propsRDDocumentar) {  

    var _ = require('underscore');
    
    //*api store
        const { guardaGetDetailbyUserPStore, propuestaDetallesStore,
                generaObjErrorProposalsStore} =  
            proposalsStore((state:any) =>( { 
                guardaGetDetailbyUserPStore: state.guardaGetDetailbyUserStore,
                propuestaDetallesStore: state.propuestaDetallesStore,
                generaObjErrorProposalsStore: state.generaObjErrorProposalsStore,
        }));

        const { guardaGetDetailbyUserAStore,  pfcDetallesStore,
                cambiaPFCDetalleStore, 
                guardaUpdatebyUserStore,
                guardaSendbyUserStore,
                nrArchivosStore, crArchivosStore, proofArchivosStore, justifyArchivosStore, apiArchivosStore,
                generaObjErrorAnalysisStore } =  
            analysisStore((state:any) =>( { 
                guardaGetDetailbyUserAStore: state.guardaGetDetailbyUserStore, 
                pfcDetallesStore: state.pfcDetallesStore, 
                cambiaPFCDetalleStore: state.cambiaPFCDetalleStore,
                guardaUpdatebyUserStore: state.guardaUpdatebyUserStore,
                guardaSendbyUserStore: state.guardaSendbyUserStore,
                nrArchivosStore: state.nrArchivosStore,
                crArchivosStore: state.crArchivosStore,
                proofArchivosStore: state.proofArchivosStore,
                justifyArchivosStore: state.justifyArchivosStore,
                apiArchivosStore: state.apiArchivosStore,
                generaObjErrorAnalysisStore: state.generaObjErrorAnalysisStore
        }));

        const { guardaUploadFilesAnalysisStore, 
                generaObjErrorFilesStore, objErrorFilesStore } =  
            filesStore((state:any) =>( { 
                guardaUploadFilesAnalysisStore: state.guardaUploadFilesAnalysisStore,
                generaObjErrorFilesStore: state.generaObjErrorFilesStore,
                objErrorFilesStore: state.objErrorFilesStore,
        })); 

        const { guardaSendEmailStore, 
                generaObjErrorNotificationsStore } =  
            notificationsStore((state:any) =>( { 
                guardaSendEmailStore: state.guardaSendEmailStore,
                generaObjErrorNotificationsStore: state.generaObjErrorNotificationsStore
        }));

    //*store's
     
    //*datos

    //*constantes y variables
        let eti = etiquetasSSC.RD;
        let etiGlobal = etiquetasSSC.Global;
        let x0, x1, x1a, x2, x3 = '';
        let msjError = "";  
        let msjAdvertencia = "";

        let date = new Date();
        let dateStr =  date.getFullYear() + "-" +
            ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
            ("00" + date.getDate()).slice(-2) + "T" +
            ("00" + date.getHours()).slice(-2) + ":" +
            ("00" + date.getMinutes()).slice(-2) + ":" +
            ("00" + date.getSeconds()).slice(-2);
            
        //para uso del dropzone
            let archivosNR:any = [];
            let archivosCR:any = [];
            let archivosPROOF:any = [];
            let archivosJUSTIFY:any = [];
            let archivosAPI:any = [];
       
    //*useState
        const [swRecarga, setSwRecarga] =  useState(false);   
        const [swRecargaRDDocumentar, setSwRecargaRDDocumentar] =  useState(false);   
        const [cargandoSpin,setCargandoSpin] = useState(false);
        const [swPFC, setSwPFC] = useState(false);

        const [totalEvidencias, setTotalEvidencias] = useState(0);   
        const [totalDecision, setTotalDecision] = useState(0);   

        const [pfcDetallesFront, setPfcDetallesFront] = useState(pfcDetallesStore);
        const [swBotonGuardarFront, setSwBotonGuardarFront] = useState(pfcDetallesStore.btnGuardar); 
        const [swBotonEnviarFront,  setSwBotonEnviarFront] = useState(pfcDetallesStore.btnEnviar); 
      
        //para uso del dropzone
            const [nrMyFiles, setNrMyFiles] = useState(nrArchivosStore); //guarda el listado de elementos (archivos) cargados por el usuario
            const [crMyFiles, setCrMyFiles] = useState(crArchivosStore); 
            const [proofMyFiles, setProofMyFiles] = useState(proofArchivosStore);
            const [justifyMyFiles, setJustifyMyFiles] = useState(justifyArchivosStore);
            const [apiMyFiles, setApiMyFiles] = useState(apiArchivosStore); 
            const [swDropzoneAdvertencia, setSwDropzoneAdvertencia] = useState(true);

        //para las propuestas
            const [propuestaDetallesFront, setPropuestaDetallesFront] = useState( { id:0, folio: '', fecha: '',sent: true, sentAt: '', description: '', createdAt: '', user:{ id:0, name:'', email:''}, origin:[{id:0, name:'', specification:'' }],
            processxfrequency: [{ id:0, processname:'', frequencyname:'', acronym: '', state_process: { pt_state:0, pt_state_description:'', onwaiting:true, leftdays:0 } }]           
            } );
            const [indexPropuesta, setIndexPropuesta] = useState(0);
            const [swAbrePropuesta, setSwAbrePropuesta] = useState(false);
        //
      
    //*useEffect
        useEffect(()=>{
            console.log('monto RD.Documentar');
           // console.log ('pfcDetallesStore',pfcDetallesStore)
        },[]);

        useEffect(()=> {  //lee API:  Analysis/GetDetailbyUse
            setCargandoSpin(true);
            let body = {id:props.pfcId}
            analysisServicio.cargaGetDetailbyUser(props.tokenStore, body) //p.id del processoxFrecuencia
              .then((response:any) => {
                if (response.status==200) {  //confirma que no hay error
                    guardaGetDetailbyUserAStore(response.data, props.pfcId, props.catDecisiones, props.catPruebas, props.catPTCaracteristicas).then( function(datos:any) { 
                        //console.log('datos:', datos);
                        setPfcDetallesFront(datos);
                    
                        //para los dropzone
                            let paso = datos.misArchivos;
                            setNrMyFiles(paso[0].archivos);
                            setCrMyFiles(paso[1].archivos);
                            setProofMyFiles(paso[2].archivos);
                            setJustifyMyFiles(paso[3].archivos);
                            setApiMyFiles(paso[4].archivos);

                        //evidencias y decisión
                            setTotalEvidencias(datos.evidence.length);
                            setTotalDecision(datos.totalDecision.length);

                        //botones guardar & enviar
                            setSwBotonGuardarFront(datos.btnGuardar)
                            setSwBotonEnviarFront(datos.btnEnviar)

                        setSwPFC(!swPFC); 
                        setSwRecarga(!swRecarga);
                    })
                } 
                setCargandoSpin(false);
              })
              .catch((ex) => {
                  console.log ("--catch - ex (cargaGetDetailbyProcess): ", ex.response.status);
                  if (ex.response.status==404) //no es error solo no tiene información
                      console.log('nota: no es error solo no tiene información')
                  else{
                      generaObjErrorAnalysisStore(ex.response, true, '', '', 'RP-Analysis/GetDetailbyUser','RD')
                      recargaPaginaSSC();
                  }
                  setCargandoSpin(false);
              })
        },[]);

        useEffect(()=> {  //usado para renderizar
            //console.log('renderizando...');
            //console.log('---pfcId:', props.pfcId);
            //console.log('---totalEvidencias:', totalEvidencias);
            //console.log('---totalDecision:', totalDecision);
            //console.log('---pfcDetallesFront:', pfcDetallesFront);
            //console.log('---pfcDetallesStore:', pfcDetallesStore);
            //console.log('---nrMyFiles:',  nrMyFiles);
            //console.log('---crMyFiles:',  crMyFiles);
            //console.log('---proofMyFiles:',  proofMyFiles);
            //console.log('---justifyMyFiles:',  justifyMyFiles);
            //console.log('---apiMyFiles:',  apiMyFiles);
            setSwRecargaRDDocumentar(!swRecargaRDDocumentar);
        },[swRecarga]);

    //*interface (parametros de entrada)

    //*funciones

        const recargaPaginaSSC = () => { props.recargaPaginaSSC() } //ejecuta la función que esta en RD

        const recargaPaginaSSC_Not = () => { props.recargaPaginaSSC_Not() } //ejecuta la función que esta RD

        const recargaRD = () => { props.recargaRD() } //ejecuta la función que esta en RD

        const recargaRDDocumentar = () => { 
            //setSwRecargaRDDocumentar(!swRecargaRDDocumentar)
            setSwRecarga(!swRecarga)
        }

        const cierraPropuesta = ()=> { setSwAbrePropuesta(false) } 

        const leePropuestaPorId = (id:any, indexP:any) => { //opciones liga-verFichaCompleta , boton-registra lee el contenido de la propuesta 
            setCargandoSpin(true);
                proposalsServicio.cargaGetDetailbyUser(props.tokenStore, id)
                .then((response:any) => {
                    if (response.status==200) {  //confirma que no hay error
                        guardaGetDetailbyUserPStore(response.data, id, null, null, 'RDDocumentar').then( function(datos:any) { 
                            //console.log('propuesta - datos: ' , datos)
                            setIndexPropuesta(indexP);
                            setPropuestaDetallesFront(datos);
                            ////recargaRDDocumentar();  
                            setSwAbrePropuesta(true);
                        })
                    } 
                    setCargandoSpin(false);
                })
                .catch((ex) => {
                    console.log ("--catch - ex (cargaGetDetailbyUser): ", ex.response.status);
                    if (ex.response.status==404) //no es error solo no tiene información
                        console.log('nota: no es error solo no tiene información')
                    else{
                        generaObjErrorProposalsStore(ex.response, true, '', '', 'RDDocumentar-Proposals/GetDetailbyUser','RD')
                        recargaPaginaSSC();
                    }
                    setCargandoSpin(false);
                })
            setCargandoSpin(false);
        } 

        const abreCierraEvidenciaDetalles = (indexEv:any, ev:any)=> {
            let paso = pfcDetallesFront.evidence[indexEv].abierto;
            pfcDetallesFront.evidence[indexEv].abierto = !paso;
            recargaRDDocumentar();
            //console.log('***************props.pfcDetalles.evidence',  props.pfcDetalles.evidence)
        }
        
        const activaBotonGuardar = () => {  setSwBotonGuardarFront(true)  }

        const activaBotonEnviar = () => { setSwBotonEnviarFront(true)  }

        const botonCerrar = () => {  
            if (swBotonGuardarFront) { //si esta activo el botón guardar hay cambios...
                    swal2.fire({
                        text: "",
                        icon: 'question',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Si',
                        cancelButtonText: 'No',
                        width: '50%',
                        html: "<div>" + eti.mensajes[5].text + "</div>",
                    }).then((result) => {
                        if (result.isConfirmed) 
                            props.botonCierraSlidingPanel('');
                        else
                            return;
                    })
            }
            else {  //cerramos SlipingPanel desde RD
                    props.botonCierraSlidingPanel('');
            } 
            ////recargaRDDocumentar();
        }
        
        const botonGuardar = () => {
            //alert('botonGuardar');
            //llamado a los archivos dropzone para llenar arreglos
                nrFilesUpload();
                crFilesUpload();
                proofFilesUpload(); 
                justifyFilesUpload();
                apiFilesUpload(); 

            //pfcDetallesStore.misArchivos[0] = 
            //console.log('...pfcDetallesStore...',pfcDetallesStore);
            //console.log('...pfcDetallesFront...',pfcDetallesFront);
            //console.clear();
            //console.log('...pfcDetallesFront.misArchivos...',pfcDetallesFront.misArchivos);
            //console.log('...nrArchivosStore...',nrArchivosStore);
            //console.log('...nrFilesNuevos...',nrFilesNuevos);
            //console.log('...archivosNR...',archivosNR); // arreglo con altas y bajas ** ojo ya se agrego a pfcDetallesStore.misArchivos[#].archivos
            
            //console.log('objErrorFilesStore.hasError', objErrorFilesStore.hasError);

            validaPlantilla();

            botonGuardarUploadFilesAnalysis() ; //primero guardamos en API: Files/UploadFilesAnalysis/ SOLO ARCHIVOS NUEVOS

            // botonGuardarUpdatebyUser(); //segundo guardamos en API: Analysis/UpdatebyUser // lo mandamos dentro de botonGuardarUploadFilesAnalysis para obligarlo a esperar la promesa 
            if ( msjAdvertencia != '' ) { 
                swal2.fire({
                    icon: 'info',
                    cancelButtonColor: '#0077c8',
                    cancelButtonText: "Cerrar",
                    showCancelButton: true,
                    showConfirmButton:false,
                    width: "50%",
                    title: 'La documentación a la propuesta de cambio fue guardada:',
                    html: " <div class='color-azul2'> <b>Importante:</b> <br/><br/><i class='mdi mdi-check color-azul2 font-size-12'></i>&nbsp;<b>Completar</b> los siguientes campos<br/></div> <div class='margin-1r'>" + msjAdvertencia + "</div> <div class='color-azul2 '> <i class='mdi mdi-check color-azul2 font-size-12'></i>&nbsp;<b>Guardar</b> la plantilla completa<br /><br /></div> <div class='color-azul2'><i class='mdi mdi-check color-azul2 font-size-12'></i>&nbsp;Para completar el proceso de tipo de cambio <b>Enviar</b> la propuesta</div>",
                })
                setSwBotonEnviarFront(false); // hasta que grabe envia
            }
            else {
               //if (!objErrorFilesStore.hasError) {
                    swal2.fire({
                        icon: 'info',
                        cancelButtonColor: '#0077c8',
                        cancelButtonText: "Cerrar",
                        showCancelButton: true,
                        showConfirmButton:false,
                        width: "50%",
                        title: 'El registro de la propuesta fue guardada..:',
                        html: "<div>" + eti.mensajes[0].text + "</div>",
                    })
                    //*ojo ver parametros;
                    //idpfc:any, idEvi:any, detalle:any, swActiva any, dondeViene:any
                    //cambiaPFCDetalleStore(props.pfcId, null, null, null, 'botonGuardar');
                                
                    setSwBotonEnviarFront(true); // hasta que grabe envia
               // }  
            }   
        }
            const validaPlantilla = () => {
                //alert('validaPlantilla');
                msjAdvertencia='';

                //*evidencias - características y pruebas
                    let swPasoC = false;
                    let swPasoP = false;
                    let swPasoPO = false;
                    let msjPasoC = '';
                    let msjPasoP = '';
                    let msjPasoPO = '';
                    //console.clear();
                    //console.log('.......................pfcDetallesStore.evidence..', pfcDetallesStore.evidence)
                    let cuentaCar = 0;
                    pfcDetallesStore.evidence.map((evi:any, indexEvi:any) => {
                        //swPasoC = false;
                        //swPasoP = false;
                        //swPasoPO = false; 

                        //console.log('indexEvi', indexEvi, ' evi.swEviCatCaracteristicas..', evi.swEviCatCaracteristicas)
                        //alert(evi.miCatCaracteristicas.length);
                        if (evi.miCatCaracteristicas.length>0) {
                            if (evi.swEviCatCaracteristicas==false) {
                                if (swPasoC==false)
                                    msjPasoC = msjPasoC +  eti.mensajes[1].text + '<br/>' + '<i> - ' + evi.name + '</i><br/>';
                                else
                                    msjPasoC = msjPasoC + '<i> - ' + evi.name + '</i><br/>';
                                swPasoC= true;
                            };
                        };

                        //console.log('indexEvi', indexEvi, ' evi.swEviCatPruebas..', evi.swEviCatPruebas)
                        //alert(evi.swEviCatPruebas);
                        if (evi.swEviCatPruebas==false) {
                            if (swPasoP==false)
                                msjPasoP = msjPasoP +  eti.mensajes[2].text + '<br/>' + '<i> - ' + evi.name + '</i><br/>';
                            else
                                msjPasoP = msjPasoP + '<i> - ' + evi.name + '</i><br/>';
                            swPasoP= true;
                        };  

                       /*  console.log('indexEvi', indexEvi, ' evi.swEviCatPruebasOtro..', evi.swEviCatPruebasOtro)
                        if (evi.swEviCatPruebasOtro==false) {
                            if (swPasoP==false)
                                msjPasoP = msjPasoP +  eti.mensajes[2].text + '<br/>' + '<i> - ' + evi.name + '</i><br/>';
                            else
                                msjPasoP = msjPasoP + '<i> - ' + evi.name + '</i><br/>';
                            swPasoP= true;
                        } */ 
                        
                        //// if (evi.swEviCatPruebasOtro==false) {
                        if (evi.miCatPruebas[4].activo) { //evi.swEviCatPruebasOtro==true
                            if (evi.miCatPruebas[4].otraTexto=='' ||  evi.miCatPruebas[4].otraTexto==null) {
                                if (swPasoPO==false)
                                    msjPasoPO = msjPasoPO +  eti.mensajes[4].text + '<br/>' + '<i> - ' + evi.name + '</i><br/>';
                                else
                                    msjPasoPO = msjPasoPO + '<i> - ' + evi.name + '</i><br/>';
                                swPasoPO= true;
                            }    
                        }
                    });
                    if (msjPasoC != '') { msjAdvertencia = msjPasoC + '<br />' }
                    if (msjPasoP != '') { msjAdvertencia = msjAdvertencia + msjPasoP + '<br />' }
                    if (msjPasoPO != '') { msjAdvertencia = msjAdvertencia + msjPasoPO + '<br />' }

                //*archivos
                    let swPasoA = false;
                    let msjPasoA = '';
                    //console.clear();
                    //console.log('***validaPlantilla()*************pfcDetallesStore.misArchivos', pfcDetallesStore.misArchivos);
                    let detectaArchABorrar = 0;
                    pfcDetallesStore.misArchivos.map((ma:any, indexMa:any) => {
                        //console.log('--',ma.idTipo, '-- ma.archivos.length', ma.archivos.length)
                        if (ma.archivos.length==0) {
                            if (ma.activo) {
                                if (swPasoA==false)
                                    msjPasoA = msjPasoA +  eti.mensajes[6].text + '<br/>' + '<i> - ' + ma.descripcion + '</i><br/>';
                                else
                                    msjPasoA = msjPasoA + '<i> - ' + ma.descripcion + '</i><br/>';
                                swPasoA= true;
                            }
                        }
                        else {
                            //console.log('pase1');
                            detectaArchABorrar=0;
                            ma.archivos.map((arch:any, indexArch:any) => {
                                //console.log('pase1');
                                if (arch.action==2) {detectaArchABorrar= detectaArchABorrar+1; } 
                            })
                            console.log('pase3', detectaArchABorrar, '--ma.archivos.length', ma.archivos.length);
                            if (ma.archivos.length == detectaArchABorrar) {
                                //console.log('pase4');
                                if (swPasoA==false)
                                    msjPasoA = msjPasoA +  eti.mensajes[6].text + '<br/>' + '<i> - ' + ma.descripcion + '</i><br/>';
                                else
                                    msjPasoA = msjPasoA + '<i> - ' + ma.descripcion + '</i><br/>';
                                swPasoA= true;

                            }
                        }
                    })  
                    if (msjPasoA != '') {msjAdvertencia = msjAdvertencia + msjPasoA  }
                    //nrFilesUpload(); //LLAMADO A ARCHIVOS DEL DROPZONE
                
                //console.log('msjAdvertencia: ',msjAdvertencia);
            }
            
            const botonGuardarUploadFilesAnalysis = () => {
                //alert('guardaArchivosNoPrevista');
                var formData = new FormData();
                formData.append("idau", props.pfcId);
                let swGuardaNvos = false;
                if (nrFilesNuevos.length > 0 ) {
                    nrFilesNuevos.map((f:any) => { formData.append("classified", f.classified) });
                    nrFilesNuevos.map((f:any) => { formData.append("Files", f) });
                    swGuardaNvos = true;
                }
                if (crFilesNuevos.length > 0 ) {
                    crFilesNuevos.map((f:any) => { formData.append("classified", f.classified) });
                    crFilesNuevos.map((f:any) => { formData.append("Files", f) });
                    swGuardaNvos = true;
                }
                if (proofFilesNuevos.length > 0 ) {
                    proofFilesNuevos.map((f:any) => { formData.append("classified", f.classified) });
                    proofFilesNuevos.map((f:any) => { formData.append("Files", f) });
                    swGuardaNvos = true;
                }
                if (justifyFilesNuevos.length > 0 ) {
                    justifyFilesNuevos.map((f:any) => { formData.append("classified", f.classified) });
                    justifyFilesNuevos.map((f:any) => { formData.append("Files", f) });
                    swGuardaNvos = true;
                }
                if (apiFilesNuevos.length > 0 ) {
                    apiFilesNuevos.map((f:any) => { formData.append("classified", f.classified) });
                    apiFilesNuevos.map((f:any) => { formData.append("Files", f) });
                    swGuardaNvos = true;
                }
                if (swGuardaNvos){
                     //*ejecutamos api Files/UploadFilesAnalysis
                    //console.log('---------------------------------formData', formData)
                    setCargandoSpin(true);
                    filesServicio.cargaUploadFilesAnalysis(props.tokenStore, formData)
                    .then((response:any) => {
                        //console.log('response.................',response)
                        if (response.status==200) {  //revisa si hay error
                            guardaUploadFilesAnalysisStore(response.data).then( function(uploadFilesAnalysisFront:any) { 
                                //console.log('-----------------------------------uploadFilesAnalysisFront', uploadFilesAnalysisFront )
                                //hasta que termine la promesa mandamos el siguiente api
                                botonGuardarUpdatebyUser(); //segundo guardamos en API: Analysis/UpdatebyUser
                                ////recargaRD();  //actualizamos páginas de atrás
                            });     
                        }    
                        setCargandoSpin(false);
                    })
                    .catch((ex) => {
                        console.log ("--catch - ex (cargaInsertbyUser): ", ex.response);
                        generaObjErrorFilesStore(ex.response, true, '', '', 'RD.documentar/UploadFilesAnalysis','RD');
                        recargaPaginaSSC();
                        setCargandoSpin(false);
                    })
                }
                else {
                    botonGuardarUpdatebyUser(); //segundo guardamos en API: Analysis/UpdatebyUser
                } 
            }

            const botonGuardarUpdatebyUser = () => {
                //*armamos body
                      let bodyUpdatebyUser = { id: 0,  evidence:[], files: [] }; 
                      let evidence:any = [];
                      let elemEvidence:any = { id:0, feature:[], proof: [] } ;
                      let feature:any = [];
                      let proof:any = [];
                      let elemProof = { id: 0, other: '' };
                      let files:any = [];
                      let elemFiles = { id: 0, action: 0, path: '', name: '', originalfullname: '', classified: '', createdAt:'' };
  
                      bodyUpdatebyUser.id = props.pfcId; //1
  
                      
                      let pasoCatP:any = [];
                      //evidence - evidencias
                          pfcDetallesStore.evidence?.map((ev:any) => {
                              feature=[];
                              elemEvidence = { id:0, feature:[], proof: [] } ;
                              elemEvidence.id = ev.id //2.1
  
                              pasoCatP = [];
                              elemEvidence = { id:0, feature:[], proof: [] } ;
                              elemEvidence.id = ev.id;
                              ev.miCatCaracteristicas?.map((cc:any) => {  if (cc.activo) { feature.push(cc.id) } });
                              elemEvidence.feature = feature; //2.2
  
                              proof=[];
                              ev.miCatPruebas?.map((cp:any) => {
                                  elemProof = { id: cp.id, other: cp.otraTexto };
                                  if (cp.activo) { proof.push(elemProof) }
                              });
                              elemEvidence.proof = proof; //2.3
  
                              evidence.push(elemEvidence);
                          });
  
                      //files - archivos   
                          pfcDetallesStore.misArchivos?.map((ma:any) => {
                              ma.archivos?.map((ar:any) => {
                              elemFiles = { id: ar.id, action: ar.action, classified: ar.classified, path: ar.path, name: ar.name, originalfullname: ar.originalfullname, createdAt: ar.createdAt  }; //3
                              files.push(elemFiles);
                              });  
                          });
  
                      bodyUpdatebyUser.evidence = evidence; //2
  
                      bodyUpdatebyUser.files = files; //3
  
                      //console.log('----bodyUpdatebyUser',bodyUpdatebyUser);
  
                //*ejecutamos api Analysis/UpdatebyUser
                      
                      setCargandoSpin(true);
                      //llamando al api: Analysis/UpdatebyUser
                      analysisServicio.cargaUpdatebyUser(props.tokenStore, bodyUpdatebyUser)
                      .then((response:any) => {
                          //console.log('response.................',response)
                          if (response.status==200) {  //revisa si hay error
                              guardaUpdatebyUserStore(response.data).then( function(updatebyUserFront:any) { 
                                  //cambiaProcesosxFrecuenciaStore(props.idPxF, miPDProposalFront.id, null, pasoDetalle, 'botonGuardarAPI'); 
                                  setSwBotonGuardarFront(false); //ya guardo lo deshabilimos boton guardar en front
  
                                  //////recargaRDDocumentar();  //actualizamos páginas de atrás
                              });     
                          }  
                          setCargandoSpin(false); 
                      })
                      .catch((ex) => {
                          console.log ("--catch - ex (cargaUpdatebyUser): ", ex.response.status);
                          generaObjErrorAnalysisStore(ex.response, true, '', '', 'VerRegistrar-Analysis/UpdateRateProposal','RD');
                          setCargandoSpin(false);
                      })
              }
        
        const botonEnviar = () => {  
           // alert('botonEnviar');
            
            let bodyAPIEnviar= {id: 0, send: true}
            bodyAPIEnviar.id= props.pfcId;

            //llamando al api: Analysis/SendbyUser
            //setCargandoSpin(true); //ojo el SendEmail tarda mucho por eso se quito el spin para que suelte la página y siga trabajando el usuario en lo que manda el correo de manera paralela
            analysisServicio.cargaSendbyUser(props.tokenStore, bodyAPIEnviar)
            .then((response:any) => {
                //console.log('response.................',response)
                if (response.status==200) {  //revisa si hay error
                    guardaSendbyUserStore(response.data).then( function(sendbyUserFront:any) { 
                        //cambiaProcesosxFrecuenciaStore(props.idPxF, miPDProposalFront.id, null, pasoDetalle, 'botonGuardarAPI'); 
                        //setSwBotonGuardarFront(false); //ya guardo lo deshabilimos boton guardar en front
                        //setSwBotonEnviarFront(false); //ya guardo lo deshabilimos boton guardar en front
                        cambiaPFCDetalleStore(props.pfcId, null, null, null, 'botonEnviar');
                         swal2.fire({
                            icon: 'info',
                            cancelButtonColor: '#0077c8',
                            cancelButtonText: "Cerrar",
                            showCancelButton: true,
                            showConfirmButton:false,
                            width: "50%",
                            title: 'La documentación ha finalizado, se notifica al Responsable de Fase de evaluación para los efectos pertinentes',
                            html: " <div class='h4 color-azul3'><br/>La propuesta de cambio esta disponible en el Tablero de control</div>",
                        });
                        //setCargandoSpin(false);
                        setSwBotonEnviarFront(false); // hasta que grabe envia
                        
                        //se genera una notificación & recarga de valores de notificaciones para el encabezado (campana)
                        let bodyAPINot= {idanalyseunit:0 }
                        bodyAPINot.idanalyseunit =  props.pfcId;
                        //setCargandoSpin(true);
                        notificationsServicio.cargaSendEmail(props.tokenStore, bodyAPINot)
                            .then((response:any) => {
                                //console.log('response.................', response)
                                guardaSendEmailStore(response.data).then( function(sendEmailFront:any) { 
                                    //console.log('se genera el correo por medio del api', sendEmailFront);
                                    /*  swal2.fire({
                                        icon: 'info',
                                        cancelButtonColor: '#0077c8',
                                        cancelButtonText: "Cerrar",
                                        showCancelButton: true,
                                        showConfirmButton:false,
                                        width: "50%",
                                        title: 'La documentación ha finalizado, se notifica al Responsable de Fase de evaluación para los efectos pertinentes',
                                        html: " <div class='h4 color-azul3'><br/>La propuesta de cambio esta disponible en el Tablero de control</div>",
                                    }); */
                                    setSwBotonEnviarFront(false); // hasta que grabe envia
                                    recargaPaginaSSC_Not(); // para recargar las notificaciones (campana) en PaginaSSC
                                }); 
                                //setCargandoSpin(false);
                            })
                            .catch((ex) => {
                                console.log ("--catch - ex (cargaSendEmail): ", ex.response.status);
                                generaObjErrorNotificationsStore(ex.response, true, '', '', 'VerRegistrar-Notificatios/SendEmail','RP');
                                //setCargandoSpin(false);
                                recargaPaginaSSC();
                            })
                        recargaRDDocumentar();  //actualizamos páginas de atrás
                        recargaRD(); //actualizamos página principal
                    });     
                }  
                //setCargandoSpin(false); 
            })
            .catch((ex) => {
                console.log ("--catch - ex (cargaSendbyUser): ", ex.response.status);
                generaObjErrorAnalysisStore(ex.response, true, '', '', 'VerRegistrar-Analysis/SendbyUser','RD');
                //setCargandoSpin(false);
            })
        }

        const desactivaBotonGuardarEnviar = () => { setSwBotonGuardarFront(false); setSwBotonEnviarFront(false)}

     //*----------DROPZONE---  NR (Revisión de necesidades) --INICIO --- *//
        //*constantes y variables
        let nrFilesIn = [] as any; //este elemento se uso para cargar archivos inválidos (puede omitirse)
        let nrMyFileCopia = [] as any; //copia de myFile (que es donde se guarda la lista de archivos cargados por el usuario) usada para hacer recorridos y comparaciones sin afectar el arreglo myFile
        let nrFilesNuevos:any = [];
      
        //const [nrMyFiles, setNrMyFiles] = useState(nrMisArchivosDropzone); //guarda el listado de elementos (archivos) cargados por el usuario//ojo lo subí al useEffect con la lectura del API
        const [nrFilesInvalid, setnrFilesInvalid] = useState([] as any); //este elemento se uso para cargar archivos inválidos
        
        //*funciones

            function NrMyDropzone() {
                //--useCallback  //ya traemos los archivos -acceptedFiles acumula lo del cuadro de dialogo-
                const onDrop = useCallback(
                    (acceptedFiles) => {
                        let acceptedFilesTemp: any = [];
                        let filesCarg = 0; //contador para saber si tenemos archivos que ya se cargaron y en su caso mostrar el toast
                        acceptedFilesTemp = [...acceptedFilesTemp, ...acceptedFiles]; //se uso para mostrar el listado que se mostraba en error con el nombre de los archivos duplicados, pero esta inhibida la rutina ya que solo se muestra el total de ellos

                        setSwBotonGuardarFront(true);
                        setSwBotonEnviarFront(false);
                        setSwDropzoneAdvertencia(false);

                        acceptedFilesTemp.map((aft:any, indexAft:any) => {
                            aft.id = indexAft;
                            aft.action = 1;
                            aft.classified = 'NR'; //*nvo
                            aft.originalfullname = aft.path //*nvo
                            aft.createdAt  = dateStr;//*nvo
                        });

                        if (nrMyFiles.length != 0) {
                            //console.log(':::: acceptedFilesTemp ', acceptedFilesTemp ) ;
                            //*el for es decrementado para que no se piedan los indices y pueda hacer bien el borrado 
                            for (let i = acceptedFilesTemp.length - 1; i >= 0; i--) {
                                if ( nrMyFiles.findIndex(
                                    (mf: any) =>
                                    mf.name.toLowerCase() ===
                                    acceptedFilesTemp[i].name.toLowerCase()
                                ) >= 0
                                ) {
                                filesCarg = filesCarg + 1;
                                acceptedFiles.splice(
                                    acceptedFiles.indexOf(acceptedFilesTemp[i]),
                                    1
                                );
                                }
                            }
                        }
                        /* acumula de acceptedFiles a nrMyFiles */
                        setNrMyFiles([...nrMyFiles, ...acceptedFiles]);
                    },
                    [nrMyFiles]
                );

                //--constantes de funcionalidades del dropzone, abre la ventana etc.
                const { getRootProps, getInputProps } = useDropzone({ onDrop });

                //--removeFile remueve los archivos de nuestra lista (remueve de uno a uno) desde bote de basura
                const removeFile = (file: any) => () => {
                    //alert('removeFile');
                    setSwBotonGuardarFront(true);
                    setSwBotonEnviarFront(false);
                    let x = etiGlobal.dropZone[11].desc;
                    swal2.fire({
                        text: "",
                        icon: "question",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Si",
                        cancelButtonText: "No",
                        // width: widthSwal,
                        width: "40%",
                        html: "<div>" + etiGlobal.dropZone[11].desc + "</div>",
                    }).then((result) => {
                        if (result.isConfirmed) {
                            const newFiles = [...nrMyFiles]; //arreglo de paso
                            newFiles.splice(newFiles.indexOf(file), 1); //se elimina el archivo
                            setNrMyFiles(newFiles); //uso común del useState, actualiza nrMyFiles
                            //console.log("newFiles *******", newFiles.length);
                            if (newFiles.length == 0) {
                                // lo que hacemos en caso de quedar vacío
                                console.log(  "removeFile: que haré si se eliminan todos los elementos"  );
                                setSwDropzoneAdvertencia(true);
                            }
                        }
                    });
                };
                //--genera el listado donde se acumulan nuestros archivos (lo que se pinta en el dropzone)
                //--cada vez que se renderiza nrMyFiles genera esta función
                const files = nrMyFiles.map((file: any) => (
                    <li key={file.name}>
                        <Row>
                        <Col sm={10} className="small align-1">
                            {file.name}
                        </Col>
                        <Col sm={2}>
                            <button  title={etiGlobal.dropZone[5].desc}   onClick={removeFile(file)}  className="btn rounded-pill " >
                               <FontAwesomeIcon icon={faTrashAlt} className="color-blue-2"  style={{ fontSize: "16px" }}  />
                            </button>
                        </Col>
                        </Row>
                    </li>
                ));

                //--vista: -pintado del dropzone (adecuado a nuestro diseño)
                return (
                <>          
                    <div className=" dropzone dz-message">
                        <section className="container backcolor-blue-7">
                            <div
                            {...getRootProps({ className: " align-3" })}
                            className="spanDrop"             
                            >
                            <input {...getInputProps()} />
                            <div className="pt-25" >                  
                                <div >{etiGlobal.dropZone[7].desc}</div>
                            </div>                
                            <br />
                            
                            </div>
                            <aside className="backcolor-blue-7">
                            {/* nuestro listado que vamos acumulando*/}
                            <ul id="files">{files}</ul>
                            </aside>
                        </section>
                    </div>
                </>
                );
            }
            const nrFilesUpload = () => {
                nrFilesIn = [] as any;
                nrMyFileCopia = [] as any;
                setnrFilesInvalid([]);
                nrMyFileCopia = [...nrMyFiles];
                //pfcDetallesStore.misArchivos[0].archivos = nrMyFiles;
                //console.log("nrMyFileCopia..---------------",nrMyFileCopia, nrFilesIn.length);
                if (nrMyFileCopia.length == 0){
                    msjAdvertencia = msjAdvertencia + '*Revisión de necesidades ' + '<br/>';
                    //console.log("msjAdvertencia", msjAdvertencia);
                    setSwDropzoneAdvertencia(false);
                    nrFilesUploadContinue();
                    //console.log('..............SwDropzoneAdvertencia', swDropzoneAdvertencia)
                }
                else {  
                    if (nrFilesIn.length > 0) {
                        //se encontraron archivos no válidos
                        swal2.fire({
                        text: "",
                        icon: "info",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Continuar",
                        cancelButtonText: "Cancelar",
                        //width: widthSwal,
                        width: "40%",
                        html: "<div>" +
                        etiGlobal.dropZone[8].desc +
                        " <strong>" +
                        nrFilesIn.length +
                        "</strong>" +
                        etiGlobal.dropZone[17].desc +
                        "<br></br>" +
                        etiGlobal.dropZone[18].desc +
                        "<br></br>" +
                        etiGlobal.dropZone[19].desc +
                        "</div>",
                        }).then((result) => {
                        if (result.isConfirmed) {
                            //setOpenDivLoading(true);
                            for (let f = nrFilesIn.length - 1; f >= 0; f--) {
                            nrMyFileCopia.splice(nrFilesIn[f].idx, 1);
                            }
                            setNrMyFiles(nrMyFileCopia);
                            setnrFilesInvalid(nrFilesIn);
                            nrFilesUploadContinue();
                            setSwRecarga(!swRecarga);
                        } else {
                            for (let f = nrFilesIn.length - 1; f >= 0; f--) {
                            nrMyFileCopia.splice(nrFilesIn[f].idx, 1);
                            }
                            setNrMyFiles(nrMyFileCopia);
                            console.log("files....", setNrMyFiles(nrMyFileCopia))
                            return;
                        }
                        });
                    }
                    //este else maneja que ya paso todo bien y va a bajar los archivo a la NAS
                    else {
                        setNrMyFiles(nrMyFileCopia);
                        setnrFilesInvalid(nrFilesIn);
                        nrFilesUploadContinue();
                        setSwRecarga(!swRecarga);
                    }
                }
            };
            const nrFilesUploadContinue = () => { 
                //alert('0'); 
                if (nrMyFileCopia.length===0){
                    msjAdvertencia = msjAdvertencia + '**Revisión de necesidades ' + '<br/>';
                }
                //else{ 
                    nrFilesIn = [] as any; 
                    nrFilesIn=nrMyFileCopia; //aquí tenemos que hay en dropzone (ya quitando los que elimino por el bote y con los nuevos)
                    //console.log("eggp nrFilesIn-----------",nrFilesIn);
                    //console.log(":::nrMyFiles-----------",nrMyFiles); //aquí los que traemos del api
                    nrFilesNuevos = _.filter(nrFilesIn, function(f:any) { return f.action == 1 });
                    console.log(":::::nrFilesNuevos-------------------",nrFilesNuevos);
                    nrGeneraAltasYBajas(nrFilesIn, nrFilesNuevos);//usado para armar la parte del file que ocupo el body del api
                    setSwRecarga(!swRecarga)
                //}   
            }

            const nrGeneraAltasYBajas = ( archivosEnDropzone: any, archivosNvos: any) => {
                //alert('1');
                //compara los dos arreglos para armar el body que ocupa: Decisions/UpdateRateProposal/es
                    //console.log('-------------- nrGeneraAltasYBajas ----------');
                    //console.log('archivosEnDropzone:  ', archivosEnDropzone);
                    //console.log('archivosNvos: ', archivosNvos);
                    archivosNR=[];
                    archivosNR= JSON.parse(JSON.stringify(nrArchivosStore));
                    //console.log('archivosNR: ', archivosNR);
                    let swSigue = false;
                    
                    //buscamos las bajas
                        let idArchivosDropzone = _.pluck(archivosEnDropzone, 'id');
                        //console.log('idArchivosOriginales.........',idArchivosDropzone);
                        archivosNR.map((a:any, indexA:any) => {
                            swSigue = false;
                            idArchivosDropzone.map((idD:any, indexidD:any) => {
                                  if (idD == a.id) {swSigue = true }
                            });
                            if (swSigue==false) { a.action = 2 }
                        });

                    //agregamos los nuevos
                       let path = props.pfcId + '\\NR';
                       if (archivosNvos.length != 0) { 
                            archivosNvos.map((n:any, indexN:any) => { 
                                archivosNR.push ({ "id": indexN, "action":1, "classified":"NR", "path": path, "name": n.name, "originalfullname":n.name, "createdAt":n.createdAt, "descarga":""})
                            })  
                       };

                    cambiaPFCDetalleStore(props.pfcId, null, archivosNR, null, 'cambiaFilesNR');  
                    console.log('archivosNR.........',archivosNR);

            }   
    //*----------DROPZONE---  NR (Revisión de necesidades) --FIN --- *//


    //*----------DROPZONE---  CR (Revisión de necesidades) --INICIO --- *//
        //*constantes y variables
        let crFilesIn = [] as any; 
        let crMyFileCopia = [] as any; 
        let crFilesNuevos:any = [];
        const [crFilesInvalid, setcrFilesInvalid] = useState([] as any); 
        
        //*funciones:
            function CrMyDropzone() {
                //--useCallback  //ya traemos los archivos (acceptedFiles acumula lo del cuadro de dialogo)
                const onDrop = useCallback(
                (acceptedFiles) => {
                    let acceptedFilesTemp: any = [];
                    let filesCarg = 0; //contador para saber si tenemos archivos que ya se cargaron y en su caso mostrar el toast
                    acceptedFilesTemp = [...acceptedFilesTemp, ...acceptedFiles]; //se uso para mostrar el listado que se mostraba en error con el nombre de los archivos duplicados, pero esta inhibida la rutina ya que solo se muestra el total de ellos

                    setSwBotonGuardarFront(true);
                    setSwBotonEnviarFront(false);
                    setSwDropzoneAdvertencia(false);

                    acceptedFilesTemp.map((aft:any, indexAft:any) => {
                        aft.id = indexAft;
                        aft.action = 1;
                        aft.classified = 'CR'; //*nvo
                        aft.originalfullname = aft.path //*nvo
                        aft.createdAt  = dateStr;//*nvo
                    });

                    if (crMyFiles.length != 0) {
                    //console.log(':::: acceptedFilesTemp ', acceptedFilesTemp ) ;
                    //*el for es decrementado para que no se piedan los indices y pueda hacer bien el borrado 
                    for (let i = acceptedFilesTemp.length - 1; i >= 0; i--) {
                        if (
                        crMyFiles.findIndex(
                            (mf: any) =>
                            mf.name.toLowerCase() ===
                            acceptedFilesTemp[i].name.toLowerCase()
                        ) >= 0
                        ) {
                        filesCarg = filesCarg + 1;
                        acceptedFiles.splice(
                            acceptedFiles.indexOf(acceptedFilesTemp[i]),
                            1
                        );
                        }
                    }
                    }
                    /* acumula de acceptedFiles a crMyFiles */
                    setCrMyFiles([...crMyFiles, ...acceptedFiles]);
                },
                [crMyFiles]
                );
                //--constantes de funcionalidades del dropzone, abre la ventana etc.
                const { getRootProps, getInputProps } = useDropzone({ onDrop });
                //--removeFile remueve los archivos de nuestra lista (remueve de uno a uno) desde bote de basura
                const removeFile = (file: any) => () => {
                //alert('removeFile');
                setSwBotonGuardarFront(true);
                setSwBotonEnviarFront(false);
                let x = etiGlobal.dropZone[11].desc;
                swal2.fire({
                    text: "",
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Si",
                    cancelButtonText: "No",
                    // width: widthSwal,
                    width: "40%",
                    html: "<div>" + etiGlobal.dropZone[11].desc + "</div>",
                }).then((result) => {
                    if (result.isConfirmed) {
                    const newFiles = [...crMyFiles]; //arreglo de paso
                    newFiles.splice(newFiles.indexOf(file), 1); //se elimina el archivo
                    setCrMyFiles(newFiles); //uso común del useState, actualiza crMyFiles
                    //console.log("newFiles *******", newFiles.length);
                    if (newFiles.length == 0) {
                        // lo que hacemos en caso de quedar vacío
                        console.log(  "removeFile: que haré si se eliminan todos los elementos"  );
                        setSwDropzoneAdvertencia(true);
                    }
                    }
                });
                };
                //--genera el listado donde se acumulan nuestros archivos (lo que se pinta en el dropzone)
                //--cada vez que se renderiza crMyFiles genera esta función
                const files = crMyFiles.map((file: any) => (
                <li key={file.name}>
                    <Row>
                    <Col sm={10} className="small align-1">
                        {file.name}
                    </Col>
                    <Col sm={2}>
                        <button  title={etiGlobal.dropZone[5].desc}   onClick={removeFile(file)}  className="btn rounded-pill " >
                        <FontAwesomeIcon icon={faTrashAlt} className="color-blue-2"  style={{ fontSize: "16px" }}  />
                        </button>
                    </Col>
                    </Row>
                </li>
                ));
                //--vista: -pintado del dropzone (adecuado a nuestro diseño)
                return (
                    <>          
                        <div className=" dropzone dz-message">
                        <section className="container backcolor-blue-7">
                            <div
                            {...getRootProps({ className: " align-3" })}
                            className="spanDrop"             
                            >
                            <input {...getInputProps()} />
                            <div className="pt-25" >                  
                                <div >{etiGlobal.dropZone[7].desc}</div>
                            </div>                
                            <br />
                            
                            </div>
                            <aside className="backcolor-blue-7">
                            {/* nuestro listado que vamos acumulando*/}
                            <ul id="files">{files}</ul>
                            </aside>
                        </section>
                        </div>
                    </>
                );
            }
            const crFilesUpload = () => {
                crFilesIn = [] as any;
                crMyFileCopia = [] as any;
                setcrFilesInvalid([]);
                crMyFileCopia = [...crMyFiles];
                //console.log("crMyFileCopia..---------------",crMyFileCopia, crFilesIn.length);
                if (crMyFileCopia.length===0){
                    msjAdvertencia = msjAdvertencia + 'Relación de cambios' + '<br/>';
                    setSwDropzoneAdvertencia(false);
                    crFilesUploadContinue();
                    //console.log('..............SwDropzoneAdvertencia', swDropzoneAdvertencia)
                }
                else {  
                if (crFilesIn.length > 0) {
                    //se encontraron archivos no válidos
                    swal2.fire({
                    text: "",
                    icon: "info",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Continuar",
                    cancelButtonText: "Cancelar",
                    //width: widthSwal,
                    width: "40%",
                    html:
                    "<div>" +
                    etiGlobal.dropZone[8].desc +
                    " <strong>" +
                    crFilesIn.length +
                    "</strong>" +
                    etiGlobal.dropZone[17].desc +
                    "<br></br>" +
                    etiGlobal.dropZone[18].desc +
                    "<br></br>" +
                    etiGlobal.dropZone[19].desc +
                    "</div>",
                    }).then((result) => {
                    if (result.isConfirmed) {
                        //setOpenDivLoading(true);
                        for (let f = crFilesIn.length - 1; f >= 0; f--) {
                        crMyFileCopia.splice(crFilesIn[f].idx, 1);
                        }
                        setCrMyFiles(crMyFileCopia);
                        setcrFilesInvalid(crFilesIn);
                        crFilesUploadContinue();
                        setSwRecarga(swRecarga);
                    } else {
                        for (let f = crFilesIn.length - 1; f >= 0; f--) {
                        crMyFileCopia.splice(crFilesIn[f].idx, 1);
                        }
                        setCrMyFiles(crMyFileCopia);
                        console.log("files....", setCrMyFiles(crMyFileCopia))
                        return;
                    }
                    });
                }
                //este else maneja que ya paso todo bien y va a bajar los archivo a la NAS
                else {
                    setCrMyFiles(crMyFileCopia);
                    setcrFilesInvalid(crFilesIn);
                    crFilesUploadContinue();
                    setSwRecarga(swRecarga);
                }
                }
            };
            const crFilesUploadContinue = () => {  
                if (crMyFileCopia.length===0){
                    msjAdvertencia = msjAdvertencia + etiGlobal.dropZone[20].desc + '<br/>';
                }
                //else{ 
                    crFilesIn = [] as any; 
                    crFilesIn=crMyFileCopia; //aquí tenemos que hay en dropzone (ya quitando los que elimino por el bote y con los nuevos)
                    //console.log("eggp crFilesIn-----------",crFilesIn);
                    //console.log(":::crMyFiles-----------",crMyFiles); //aquí los que traemos del api
                    crFilesNuevos = _.filter(crFilesIn, function(f:any) { return f.action == 1 });
                    //console.log(":::crFilesNuevos-------------------",crFilesNuevos);
                    crGeneraAltasYBajas(crFilesIn, crFilesNuevos);//usado para armar la parte del file que ocupo el body del api
                    setSwRecarga(!swRecarga)
                //}   
            }     
            const crGeneraAltasYBajas = ( archivosEnDropzone: any, archivosNvos: any) => {
                //compara los dos arreglos para armar el body que ocupa: Decisions/UpdateRateProposal/es
                    //console.log('-------------- crGeneraAltasYBajas ----------');
                    //console.log('archivosEnDropzone:  ', archivosEnDropzone);
                    //console.log('archivosNvos: ', archivosNvos);
                    archivosCR=[];
                    archivosCR= JSON.parse(JSON.stringify(crArchivosStore));
                    let swSigue = false;
                    
                    //buscamos las bajas
                        let idArchivosDropzone = _.pluck(archivosEnDropzone, 'id');
                        //console.log('idArchivosOriginales.........',idArchivosDropzone);
                        archivosCR.map((a:any, indexA:any) => {
                            swSigue = false;
                            idArchivosDropzone.map((idD:any, indexidD:any) => {
                                  if (idD == a.id) {swSigue = true }
                            });
                            if (!swSigue) { a.action = 2 }
                        });

                    //agregamos los nuevos
                       let path = props.pfcId + '\\CR';
                       if (archivosNvos.length != 0) { 
                            archivosNvos.map((n:any, indexN:any) => { 
                                archivosCR.push ({ "id": indexN, "action":1, "classified":"CR", "path": path, "name": n.name, "originalfullname":n.name, "createdAt":n.createdAt, "descarga":""})
                            })  
                       };
                    cambiaPFCDetalleStore(props.pfcId, null, archivosCR, null, 'cambiaFilesCR');  
                    console.log('archivosCR.........',archivosCR);

            }    
    //*----------DROPZONE---  CR (Revisión de necesidades) --FIN --- *//

    //*----------DROPZONE---  PROOF (Revisión de necesidades) --INICIO --- *//
        //*constantes y variables
        let proofFilesIn = [] as any; 
        let proofMyFileCopia = [] as any; 
        let proofFilesNuevos:any = [];
        const [proofFilesInvalid, setproofFilesInvalid] = useState([] as any); 
        
        //*funciones:
            function ProofMyDropzone() {
                //--useCallback  //ya traemos los archivos (acceptedFiles acumula lo del cuadro de dialogo)
                const onDrop = useCallback(
                (acceptedFiles) => {
                    let acceptedFilesTemp: any = [];
                    let filesCarg = 0; //contador para saber si tenemos archivos que ya se cargaron y en su caso mostrar el toast
                    acceptedFilesTemp = [...acceptedFilesTemp, ...acceptedFiles]; //se uso para mostrar el listado que se mostraba en error con el nombre de los archivos duplicados, pero esta inhibida la rutina ya que solo se muestra el total de ellos

                    setSwBotonGuardarFront(true);
                    setSwBotonEnviarFront(false);
                    setSwDropzoneAdvertencia(false);

                    acceptedFilesTemp.map((aft:any, indexAft:any) => {
                        aft.id = indexAft;
                        aft.action = 1;
                        aft.classified = 'PROOF'; //*nvo
                        aft.originalfullname = aft.path //*nvo
                        aft.createdAt  = dateStr;//*nvo
                    });

                    if (proofMyFiles.length != 0) {
                    //console.log(':::: acceptedFilesTemp ', acceptedFilesTemp ) ;
                    //*el for es decrementado para que no se piedan los indices y pueda hacer bien el borrado 
                    for (let i = acceptedFilesTemp.length - 1; i >= 0; i--) {
                        if (
                        proofMyFiles.findIndex(
                            (mf: any) =>
                            mf.name.toLowerCase() ===
                            acceptedFilesTemp[i].name.toLowerCase()
                        ) >= 0
                        ) {
                        filesCarg = filesCarg + 1;
                        acceptedFiles.splice(
                            acceptedFiles.indexOf(acceptedFilesTemp[i]),
                            1
                        );
                        }
                    }
                    }
                    /* acumula de acceptedFiles a proofMyFiles */
                    setProofMyFiles([...proofMyFiles, ...acceptedFiles]);
                },
                [proofMyFiles]
                );
                //--constantes de funcionalidades del dropzone, abre la ventana etc.
                const { getRootProps, getInputProps } = useDropzone({ onDrop });
                //--removeFile remueve los archivos de nuestra lista (remueve de uno a uno) desde bote de basura
                const removeFile = (file: any) => () => {
                //alert('removeFile');
                setSwBotonGuardarFront(true);
                setSwBotonEnviarFront(false);
                let x = etiGlobal.dropZone[11].desc;
                swal2.fire({
                    text: "",
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Si",
                    cancelButtonText: "No",
                    // width: widthSwal,
                    width: "40%",
                    html: "<div>" + etiGlobal.dropZone[11].desc + "</div>",
                }).then((result) => {
                    if (result.isConfirmed) {
                    const newFiles = [...proofMyFiles]; //arreglo de paso
                    newFiles.splice(newFiles.indexOf(file), 1); //se elimina el archivo
                    setProofMyFiles(newFiles); //uso común del useState, actualiza proofMyFiles
                    //console.log("newFiles *******", newFiles.length);
                    if (newFiles.length == 0) {
                        // lo que hacemos en caso de quedar vacío
                        console.log(  "removeFile: que haré si se eliminan todos los elementos"  );
                        setSwDropzoneAdvertencia(true);
                    }
                    }
                });
                };
                //--genera el listado donde se acumulan nuestros archivos (lo que se pinta en el dropzone)
                //--cada vez que se renderiza proofMyFiles genera esta función
                const files = proofMyFiles.map((file: any) => (
                <li key={file.name}>
                    <Row>
                    <Col sm={10} className="small align-1">
                        {file.name}
                    </Col>
                    <Col sm={2}>
                        <button  title={etiGlobal.dropZone[5].desc}   onClick={removeFile(file)}  className="btn rounded-pill " >
                        <FontAwesomeIcon icon={faTrashAlt} className="color-blue-2"  style={{ fontSize: "16px" }}  />
                        </button>
                    </Col>
                    </Row>
                </li>
                ));
                //--vista: -pintado del dropzone (adecuado a nuestro diseño)
                return (
                <>          
                    <div className=" dropzone dz-message">
                    <section className="container backcolor-blue-7">
                        <div
                        {...getRootProps({ className: " align-3" })}
                        className="spanDrop"             
                        >
                        <input {...getInputProps()} />
                        <div className="pt-25" >                  
                            <div >{etiGlobal.dropZone[7].desc}</div>
                        </div>                
                        <br />
                        
                        </div>
                        <aside className="backcolor-blue-7">
                        {/* nuestro listado que vamos acumulando*/}
                        <ul id="files">{files}</ul>
                        </aside>
                    </section>
                    </div>
                </>
                );
            }
            const proofFilesUpload = () => {
                proofFilesIn = [] as any;
                proofMyFileCopia = [] as any;
                setproofFilesInvalid([]);
                proofMyFileCopia = [...proofMyFiles];
                //console.log("proofMyFileCopia..---------------",proofMyFileCopia, proofFilesIn.length);
                if (proofMyFileCopia.length===0){
                    msjAdvertencia = msjAdvertencia + '*Reporte de resultados de las pruebas' + '<br/>';
                    setSwDropzoneAdvertencia(false);
                    proofFilesUploadContinue();
                    //console.log('..............SwDropzoneAdvertencia', swDropzoneAdvertencia)
                }
                else {  
                if (proofFilesIn.length > 0) {
                    //se encontraron archivos no válidos
                    swal2.fire({
                    text: "",
                    icon: "info",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Continuar",
                    cancelButtonText: "Cancelar",
                    //width: widthSwal,
                    width: "40%",
                    html:
                    "<div>" +
                    etiGlobal.dropZone[8].desc +
                    " <strong>" +
                    proofFilesIn.length +
                    "</strong>" +
                    etiGlobal.dropZone[17].desc +
                    "<br></br>" +
                    etiGlobal.dropZone[18].desc +
                    "<br></br>" +
                    etiGlobal.dropZone[19].desc +
                    "</div>",
                    }).then((result) => {
                    if (result.isConfirmed) {
                        //setOpenDivLoading(true);
                        for (let f = proofFilesIn.length - 1; f >= 0; f--) {
                        proofMyFileCopia.splice(proofFilesIn[f].idx, 1);
                        }
                        setProofMyFiles(proofMyFileCopia);
                        setproofFilesInvalid(proofFilesIn);
                        proofFilesUploadContinue();
                        setSwRecarga(swRecarga);
                    } else {
                        for (let f = proofFilesIn.length - 1; f >= 0; f--) {
                        proofMyFileCopia.splice(proofFilesIn[f].idx, 1);
                        }
                        setProofMyFiles(proofMyFileCopia);
                        console.log("files....", setProofMyFiles(proofMyFileCopia))
                        return;
                    }
                    });
                }
                //este else maneja que ya paso todo bien y va a bajar los archivo a la NAS
                else {
                    setProofMyFiles(proofMyFileCopia);
                    setproofFilesInvalid(proofFilesIn);
                    proofFilesUploadContinue();
                    setSwRecarga(swRecarga);
                }
                }
            };
            const proofFilesUploadContinue = () => {  
                if (proofMyFileCopia.length===0){
                    msjAdvertencia = msjAdvertencia + etiGlobal.dropZone[20].desc + '<br/>';
                }
                //else{ 
                    proofFilesIn = [] as any; 
                    proofFilesIn=proofMyFileCopia; //aquí tenemos que hay en dropzone (ya quitando los que elimino por el bote y con los nuevos)
                    //console.log("eggp proofFilesIn-----------",proofFilesIn);
                    //console.log(":::proofMyFiles-----------",proofMyFiles); //aquí los que traemos del api
                    proofFilesNuevos = _.filter(proofFilesIn, function(f:any) { return f.action == 1 });
                    //console.log(":::proofFilesNuevos-------------------",proofFilesNuevos);
                    proofGeneraAltasYBajas(proofFilesIn, proofFilesNuevos);//usado para armar la parte del file que ocupo el body del api
                    setSwRecarga(!swRecarga)
                //}   
            }     
            const proofGeneraAltasYBajas = ( archivosEnDropzone: any, archivosNvos: any) => {
                //compara los dos arreglos para armar el body que ocupa: Decisions/UpdateRateProposal/es
                    //console.log('-------------- proofGeneraAltasYBajas ----------');
                    //console.log('archivosEnDropzone:  ', archivosEnDropzone);
                    //console.log('archivosNvos: ', archivosNvos);
                    archivosPROOF=[];
                    archivosPROOF= JSON.parse(JSON.stringify(proofArchivosStore));
                    let swSigue = false;
                    
                    //buscamos las bajas
                        let idArchivosDropzone = _.pluck(archivosEnDropzone, 'id');
                        //console.log('idArchivosOriginales.........',idArchivosDropzone);
                        archivosPROOF.map((a:any, indexA:any) => {
                            swSigue = false;
                            idArchivosDropzone.map((idD:any, indexidD:any) => {
                                  if (idD == a.id) {swSigue = true }
                            });
                            if (!swSigue) { a.action = 2 }
                        });

                    //agregamos los nuevos
                       let path = props.pfcId + '\\PROOF';
                       if (archivosNvos.length != 0) { 
                            archivosNvos.map((n:any, indexN:any) => { 
                                archivosPROOF.push ({ "id": indexN, "action":1, "classified":"PROOF", "path": path, "name": n.name, "originalfullname":n.name, "createdAt":n.createdAt, "descarga":""})
                            })  
                       };
                    cambiaPFCDetalleStore(props.pfcId, null, archivosPROOF, null, 'cambiaFilesPROOF');  
                    console.log('archivosPROOF.........',archivosPROOF);

            }   
    //*----------DROPZONE---  PROOF (Revisión de necesidades) --FIN --- *//

    //*----------DROPZONE---  JUSTIFY(Revisión de necesidades) --INICIO --- *//
        //*constantes y variables
        let justifyFilesIn = [] as any; 
        let justifyMyFileCopia = [] as any; 
        let justifyFilesNuevos:any = [];
        const [justifyFilesInvalid, setjustifyFilesInvalid] = useState([] as any); 
        
        //*funciones:
            function JustifyMyDropzone() {
                //--useCallback  //ya traemos los archivos (acceptedFiles acumula lo del cuadro de dialogo)
                const onDrop = useCallback(
                (acceptedFiles) => {
                    let acceptedFilesTemp: any = [];
                    let filesCarg = 0; //contador para saber si tenemos archivos que ya se cargaron y en su caso mostrar el toast
                    acceptedFilesTemp = [...acceptedFilesTemp, ...acceptedFiles]; //se uso para mostrar el listado que se mostraba en error con el nombre de los archivos duplicados, pero esta inhibida la rutina ya que solo se muestra el total de ellos

                    setSwBotonGuardarFront(true);
                    setSwBotonEnviarFront(false);
                    setSwDropzoneAdvertencia(false);

                    acceptedFilesTemp.map((aft:any, indexAft:any) => {
                        aft.id = indexAft;
                        aft.action = 1;
                        aft.classified = 'JUSTIFY'; //*nvo
                        aft.originalfullname = aft.path //*nvo
                        aft.createdAt  = dateStr;//*nvo
                    });

                    if (justifyMyFiles.length != 0) {
                    //console.log(':::: acceptedFilesTemp ', acceptedFilesTemp ) ;
                    //*el for es decrementado para que no se piedan los indices y pueda hacer bien el borrado 
                    for (let i = acceptedFilesTemp.length - 1; i >= 0; i--) {
                        if (
                        justifyMyFiles.findIndex(
                            (mf: any) =>
                            mf.name.toLowerCase() ===
                            acceptedFilesTemp[i].name.toLowerCase()
                        ) >= 0
                        ) {
                        filesCarg = filesCarg + 1;
                        acceptedFiles.splice(
                            acceptedFiles.indexOf(acceptedFilesTemp[i]),
                            1
                        );
                        }
                    }
                    }
                    /* acumula de acceptedFiles a justifyMyFiles */
                    setJustifyMyFiles([...justifyMyFiles, ...acceptedFiles]);
                },
                [justifyMyFiles]
                );
                //--constantes de funcionalidades del dropzone, abre la ventana etc.
                const { getRootProps, getInputProps } = useDropzone({ onDrop });
                //--removeFile remueve los archivos de nuestra lista (remueve de uno a uno) desde bote de basura
                const removeFile = (file: any) => () => {
                //alert('removeFile');
                setSwBotonGuardarFront(true);
                setSwBotonEnviarFront(false);
                let x = etiGlobal.dropZone[11].desc;
                swal2.fire({
                    text: "",
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Si",
                    cancelButtonText: "No",
                    // width: widthSwal,
                    width: "40%",
                    html: "<div>" + etiGlobal.dropZone[11].desc + "</div>",
                }).then((result) => {
                    if (result.isConfirmed) {
                    const newFiles = [...justifyMyFiles]; //arreglo de paso
                    newFiles.splice(newFiles.indexOf(file), 1); //se elimina el archivo
                    setJustifyMyFiles(newFiles); //uso común del useState, actualiza justifyMyFiles
                    //console.log("newFiles *******", newFiles.length);
                    if (newFiles.length == 0) {
                        // lo que hacemos en caso de quedar vacío
                        console.log(  "removeFile: que haré si se eliminan todos los elementos"  );
                        setSwDropzoneAdvertencia(true);
                    }
                    }
                });
                };
                //--genera el listado donde se acumulan nuestros archivos (lo que se pinta en el dropzone)
                //--cada vez que se renderiza justifyMyFiles genera esta función
                const files = justifyMyFiles.map((file: any) => (
                <li key={file.name}>
                    <Row>
                    <Col sm={10} className="small align-1">
                        {file.name}
                    </Col>
                    <Col sm={2}>
                        <button  title={etiGlobal.dropZone[5].desc}   onClick={removeFile(file)}  className="btn rounded-pill " >
                        <FontAwesomeIcon icon={faTrashAlt} className="color-blue-2"  style={{ fontSize: "16px" }}  />
                        </button>
                    </Col>
                    </Row>
                </li>
                ));
                //--vista: -pintado del dropzone (adecuado a nuestro diseño)
                return (
                <>          
                    <div className=" dropzone dz-message">
                    <section className="container backcolor-blue-7">
                        <div
                        {...getRootProps({ className: " align-3" })}
                        className="spanDrop"             
                        >
                        <input {...getInputProps()} />
                        <div className="pt-25" >                  
                            <div >{etiGlobal.dropZone[7].desc}</div>
                        </div>                
                        <br />
                        
                        </div>
                        <aside className="backcolor-blue-7">
                        {/* nuestro listado que vamos acumulando*/}
                        <ul id="files">{files}</ul>
                        </aside>
                    </section>
                    </div>
                </>
                );
            }
            const justifyFilesUpload = () => {
                justifyFilesIn = [] as any;
                justifyMyFileCopia = [] as any;
                setjustifyFilesInvalid([]);
                justifyMyFileCopia = [...justifyMyFiles];
                //console.log("justifyMyFileCopia..---------------",justifyMyFileCopia, justifyFilesIn.length);
                if (justifyMyFileCopia.length===0){
                    msjAdvertencia = msjAdvertencia + '*Plan de acción' + '<br/>';
                    setSwDropzoneAdvertencia(false);
                    justifyFilesUploadContinue();
                    //console.log('..............SwDropzoneAdvertencia', swDropzoneAdvertencia)
                }
                else {  
                if (justifyFilesIn.length > 0) {
                    //se encontraron archivos no válidos
                    swal2.fire({
                    text: "",
                    icon: "info",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Continuar",
                    cancelButtonText: "Cancelar",
                    //width: widthSwal,
                    width: "40%",
                    html:
                    "<div>" +
                    etiGlobal.dropZone[8].desc +
                    " <strong>" +
                    justifyFilesIn.length +
                    "</strong>" +
                    etiGlobal.dropZone[17].desc +
                    "<br></br>" +
                    etiGlobal.dropZone[18].desc +
                    "<br></br>" +
                    etiGlobal.dropZone[19].desc +
                    "</div>",
                    }).then((result) => {
                    if (result.isConfirmed) {
                        //setOpenDivLoading(true);
                        for (let f = justifyFilesIn.length - 1; f >= 0; f--) {
                        justifyMyFileCopia.splice(justifyFilesIn[f].idx, 1);
                        }
                        setJustifyMyFiles(justifyMyFileCopia);
                        setjustifyFilesInvalid(justifyFilesIn);
                        justifyFilesUploadContinue();
                        setSwRecarga(swRecarga);
                    } else {
                        for (let f = justifyFilesIn.length - 1; f >= 0; f--) {
                        justifyMyFileCopia.splice(justifyFilesIn[f].idx, 1);
                        }
                        setJustifyMyFiles(justifyMyFileCopia);
                        console.log("files....", setJustifyMyFiles(justifyMyFileCopia))
                        return;
                    }
                    });
                }
                //este else maneja que ya paso todo bien y va a bajar los archivo a la NAS
                else {
                    setJustifyMyFiles(justifyMyFileCopia);
                    setjustifyFilesInvalid(justifyFilesIn);
                    justifyFilesUploadContinue();
                    setSwRecarga(swRecarga);
                }
                }
            };
            const justifyFilesUploadContinue = () => {  
                if (justifyMyFileCopia.length===0){
                    msjAdvertencia = msjAdvertencia + etiGlobal.dropZone[20].desc + '<br/>';
                }
                //else{ 
                    justifyFilesIn = [] as any; 
                    justifyFilesIn=justifyMyFileCopia; //aquí tenemos que hay en dropzone (ya quitando los que elimino por el bote y con los nuevos)
                    //console.log("eggp justifyFilesIn-----------",justifyFilesIn);
                    //console.log(":::justifyMyFiles-----------",justifyMyFiles); //aquí los que traemos del api
                    justifyFilesNuevos = _.filter(justifyFilesIn, function(f:any) { return f.action == 1 });
                    //console.log(":::justifyFilesNuevos-------------------",justifyFilesNuevos);
                    justifyGeneraAltasYBajas(justifyFilesIn, justifyFilesNuevos);//usado para armar la parte del file que ocupo el body del api
                    setSwRecarga(!swRecarga)
                //}   
            }     
            const justifyGeneraAltasYBajas = ( archivosEnDropzone: any, archivosNvos: any) => {
                //compara los dos arreglos para armar el body que ocupa: Decisions/UpdateRateProposal/es
                    //console.log('-------------- justifyGeneraAltasYBajas ----------');
                    //console.log('archivosEnDropzone:  ', archivosEnDropzone);
                    //console.log('archivosNvos: ', archivosNvos);
                    archivosJUSTIFY=[];
                    archivosJUSTIFY= JSON.parse(JSON.stringify(justifyArchivosStore));
                    let swSigue = false;
                    
                    //buscamos las bajas
                        let idArchivosDropzone = _.pluck(archivosEnDropzone, 'id');
                        //console.log('idArchivosOriginales.........',idArchivosDropzone);
                        archivosJUSTIFY.map((a:any, indexA:any) => {
                            swSigue = false;
                            idArchivosDropzone.map((idD:any, indexidD:any) => {
                                  if (idD == a.id) {swSigue = true }
                            });
                            if (!swSigue) { a.action = 2 }
                        });

                    //agregamos los nuevos
                       let path = props.pfcId + '\\JUSTIFY';
                       if (archivosNvos.length != 0) { 
                            archivosNvos.map((n:any, indexN:any) => { 
                                archivosJUSTIFY.push ({ "id": indexN, "action":1, "classified":"JUSTIFY", "path": path, "name": n.name, "originalfullname":n.name, "createdAt":n.createdAt, "descarga":""})
                            })  
                       };
                    cambiaPFCDetalleStore(props.pfcId, null, archivosJUSTIFY, null, 'cambiaFilesJUSTIFY');  
                    console.log('archivosJUSTIFY.........',archivosJUSTIFY);

            }     
    //*----------DROPZONE---  JUSTIFY(Revisión de necesidades) --FIN --- *//  

    //*----------DROPZONE---  API(Revisión de necesidades) --INICIO --- *//
        //*constantes y variables
        let apiFilesIn = [] as any;
        let apiMyFileCopia = [] as any;
        let apiFilesNuevos:any = [];
        const [apiFilesInvalid, setapiFilesInvalid] = useState([] as any); 
        
        //*funciones:
            function ApiMyDropzone() {
                //--useCallback  //ya traemos los archivos (acceptedFiles acumula lo del cuadro de dialogo)
                const onDrop = useCallback(
                (acceptedFiles) => {
                    let acceptedFilesTemp: any = [];
                    let filesCarg = 0; //contador para saber si tenemos archivos que ya se cargaron y en su caso mostrar el toast
                    acceptedFilesTemp = [...acceptedFilesTemp, ...acceptedFiles]; //se uso para mostrar el listado que se mostraba en error con el nombre de los archivos duplicados, pero esta inhibida la rutina ya que solo se muestra el total de ellos

                    setSwBotonGuardarFront(true);
                    setSwBotonEnviarFront(false);
                    setSwDropzoneAdvertencia(false);

                    acceptedFilesTemp.map((aft:any, indexAft:any) => {
                        aft.id = indexAft;
                        aft.action = 1;
                        aft.classified = 'API'; //*nvo
                        aft.originalfullname = aft.path //*nvo
                        aft.createdAt  = dateStr;//*nvo
                    });

                    if (apiMyFiles.length != 0) {
                    //console.log(':::: acceptedFilesTemp ', acceptedFilesTemp ) ;
                    //*el for es decrementado para que no se piedan los indices y pueda hacer bien el borrado 
                    for (let i = acceptedFilesTemp.length - 1; i >= 0; i--) {
                        if (
                        apiMyFiles.findIndex(
                            (mf: any) =>
                            mf.name.toLowerCase() ===
                            acceptedFilesTemp[i].name.toLowerCase()
                        ) >= 0
                        ) {
                        filesCarg = filesCarg + 1;
                        acceptedFiles.splice(
                            acceptedFiles.indexOf(acceptedFilesTemp[i]),
                            1
                        );
                        }
                    }
                    }
                    /* acumula de acceptedFiles a apiMyFiles */
                    setApiMyFiles([...apiMyFiles, ...acceptedFiles]);
                },
                [apiMyFiles]
                );
                //--constantes de funcionalidades del dropzone, abre la ventana etc.
                const { getRootProps, getInputProps } = useDropzone({ onDrop });
                //--removeFile remueve los archivos de nuestra lista (remueve de uno a uno) desde bote de basura
                const removeFile = (file: any) => () => {
                //alert('removeFile');
                setSwBotonGuardarFront(true);
                setSwBotonEnviarFront(false);
                let x = etiGlobal.dropZone[11].desc;
                swal2.fire({
                    text: "",
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Si",
                    cancelButtonText: "No",
                    // width: widthSwal,
                    width: "40%",
                    html: "<div>" + etiGlobal.dropZone[11].desc + "</div>",
                }).then((result) => {
                    if (result.isConfirmed) {
                    const newFiles = [...apiMyFiles]; //arreglo de paso
                    newFiles.splice(newFiles.indexOf(file), 1); //se elimina el archivo
                    setApiMyFiles(newFiles); //uso común del useState, actualiza apiMyFiles
                    //console.log("newFiles *******", newFiles.length);
                    if (newFiles.length == 0) {
                        // lo que hacemos en caso de quedar vacío
                        console.log(  "removeFile: que haré si se eliminan todos los elementos"  );
                        setSwDropzoneAdvertencia(true);
                    }
                    }
                });
                };
                //--genera el listado donde se acumulan nuestros archivos (lo que se pinta en el dropzone)
                //--cada vez que se renderiza apiMyFiles genera esta función
                const files = apiMyFiles.map((file: any) => (
                <li key={file.name}>
                    <Row>
                    <Col sm={10} className="small align-1">
                        {file.name}
                    </Col>
                    <Col sm={2}>
                        <button  title={etiGlobal.dropZone[5].desc}   onClick={removeFile(file)}  className="btn rounded-pill " >
                        <FontAwesomeIcon icon={faTrashAlt} className="color-blue-2"  style={{ fontSize: "16px" }}  />
                        </button>
                    </Col>
                    </Row>
                </li>
                ));
                //--vista: -pintado del dropzone (adecuado a nuestro diseño)
                return (
                <>          
                    <div className=" dropzone dz-message">
                    <section className="container backcolor-blue-7">
                        <div
                        {...getRootProps({ className: " align-3" })}
                        className="spanDrop"             
                        >
                        <input {...getInputProps()} />
                        <div className="pt-25" >                  
                            <div >{etiGlobal.dropZone[7].desc}</div>
                        </div>                
                        <br />
                        
                        </div>
                        <aside className="backcolor-blue-7">
                        {/* nuestro listado que vamos acumulando*/}
                        <ul id="files">{files}</ul>
                        </aside>
                    </section>
                    </div>
                </>
                );
            }
            const apiFilesUpload = () => {
                apiFilesIn = [] as any;
                apiMyFileCopia = [] as any;
                setapiFilesInvalid([]);
                apiMyFileCopia = [...apiMyFiles];
                //console.log("apiMyFileCopia..---------------",apiMyFileCopia, apiFilesIn.length);
                if (apiMyFileCopia.length===0){
                    msjAdvertencia = msjAdvertencia + '*Justificación de no realizar pruebas' + '<br/>';
                    setSwDropzoneAdvertencia(false);
                    apiFilesUploadContinue();
                    //console.log('..............SwDropzoneAdvertencia', swDropzoneAdvertencia)
                }
                else {  
                if (apiFilesIn.length > 0) {
                    //se encontraron archivos no válidos
                    swal2.fire({
                    text: "",
                    icon: "info",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Continuar",
                    cancelButtonText: "Cancelar",
                    //width: widthSwal,
                    width: "40%",
                    html:
                    "<div>" +
                    etiGlobal.dropZone[8].desc +
                    " <strong>" +
                    apiFilesIn.length +
                    "</strong>" +
                    etiGlobal.dropZone[17].desc +
                    "<br></br>" +
                    etiGlobal.dropZone[18].desc +
                    "<br></br>" +
                    etiGlobal.dropZone[19].desc +
                    "</div>",
                    }).then((result) => {
                    if (result.isConfirmed) {
                        //setOpenDivLoading(true);
                        for (let f = apiFilesIn.length - 1; f >= 0; f--) {
                        apiMyFileCopia.splice(apiFilesIn[f].idx, 1);
                        }
                        setApiMyFiles(apiMyFileCopia);
                        setapiFilesInvalid(apiFilesIn);
                        apiFilesUploadContinue();
                        setSwRecarga(swRecarga);
                    } else {
                        for (let f = apiFilesIn.length - 1; f >= 0; f--) {
                        apiMyFileCopia.splice(apiFilesIn[f].idx, 1);
                        }
                        setApiMyFiles(apiMyFileCopia);
                        console.log("files....", setApiMyFiles(apiMyFileCopia))
                        return;
                    }
                    });
                }
                //este else maneja que ya paso todo bien y va a bajar los archivo a la NAS
                else {
                    setApiMyFiles(apiMyFileCopia);
                    setapiFilesInvalid(apiFilesIn);
                    apiFilesUploadContinue();
                    setSwRecarga(swRecarga);
                }
                }
            };
            const apiFilesUploadContinue = () => {  
                if (apiMyFileCopia.length===0){
                    msjAdvertencia = msjAdvertencia + etiGlobal.dropZone[20].desc + '<br/>';
                }
                //else{ 
                    apiFilesIn = [] as any; 
                    apiFilesIn=apiMyFileCopia; //aquí tenemos que hay en dropzone (ya quitando los que elimino por el bote y con los nuevos)
                    //console.log("eggp apiFilesIn-----------",apiFilesIn);
                    //console.log(":::apiMyFiles-----------",apiMyFiles); //aquí los que traemos del api
                    apiFilesNuevos = _.filter(apiFilesIn, function(f:any) { return f.action == 1 });
                    //console.log(":::apiFilesNuevos-------------------",apiFilesNuevos);
                    apiGeneraAltasYBajas(apiFilesIn, apiFilesNuevos);//usado para armar la parte del file que ocupo el body del api
                    setSwRecarga(!swRecarga)
                //}   
            }     
            const apiGeneraAltasYBajas = ( archivosEnDropzone: any, archivosNvos: any) => {
                //compara los dos arreglos para armar el body que ocupa: Decisions/UpdateRateProposal/es
                    //console.log('-------------- apiGeneraAltasYBajas ----------');
                    //console.log('archivosEnDropzone:  ', archivosEnDropzone);
                    //console.log('archivosNvos: ', archivosNvos);
                    archivosAPI=[];
                    archivosAPI= JSON.parse(JSON.stringify(apiArchivosStore));
                    let swSigue = false;
                    
                    //buscamos las bajas
                        let idArchivosDropzone = _.pluck(archivosEnDropzone, 'id');
                        //console.log('idArchivosOriginales.........',idArchivosDropzone);
                        archivosAPI.map((a:any, indexA:any) => {
                            swSigue = false;
                            idArchivosDropzone.map((idD:any, indexidD:any) => {
                                  if (idD == a.id) {swSigue = true }
                            });
                            if (!swSigue) { a.action = 2 }
                        });

                    //agregamos los nuevos
                       let path = props.pfcId + '\\API';
                       if (archivosNvos.length != 0) { 
                            archivosNvos.map((n:any, indexN:any) => { 
                                archivosAPI.push ({ "id": indexN, "action":1, "classified":"API", "path": path, "name": n.name, "originalfullname":n.name, "createdAt":n.createdAt, "descarga":""})
                            })  
                       };
                    cambiaPFCDetalleStore(props.pfcId, null, archivosAPI, null, 'cambiaFilesAPI');  
                    console.log('archivosAPI.........',archivosAPI);

            }      
    //*----------DROPZONE---  API(Revisión de necesidades) --FIN --- *//  

    //*vista
     return (
      <>
          {/* encabezado: acronimo & frecuencia & ciclo & decisiones tomadas en RP */}
          {/* subencabezado: nombre del proceso  & estado del proceso*/}
            <div>
                <h4>{pfcDetallesFront.acronym} / {pfcDetallesFront.frequencyname} / {pfcDetallesFront.cyclename} &nbsp; 
                    { pfcDetallesFront.decisionTexto?.map((dt:any, indexdT:any) => (
                        (<>
                            <span className="noBR font-size-12 color-azul6 " key={indexdT}>
                                <i className="mdi mdi-checkbox-marked-circle color-naranja"></i>{dt}&nbsp; &nbsp;
                            </span>
                        </>)
                    ))}  
                </h4>
                <h5 className="color-azul5">{pfcDetallesFront.processname} &nbsp;
                    <span className={pfcDetallesFront.clasexEstatusIcono}>
                        {pfcDetallesFront.estatusProceso} </span>
                </h5>
            </div>

          <hr />

          {/* contenido */}
            <div id="SlidingPanel_contenido">

                {/* Propuesta(s) */}
                    <div>
                      {/*Propuesta(s) de cambio completa(s) */}  
                        <span className="h6 pt-3 ">{eti.contenido[1].text}</span>&nbsp;

                      {/* lista de propuesta(s) */}  
                        { pfcDetallesFront.proposal?.map((p:any, indexP:any) => (
                            (x0 =  `prop_${p.id}`),
                            (<>
                                <span className="noBR font-size-12 color-azul6 " >&nbsp;
                                    <a id={x0} onClick={()=>leePropuestaPorId(p.id, indexP)} className="text-link cursorHand ng-binding">{p.folio}</a>&nbsp;&nbsp;
                                </span>
                            </>)
                        ))}
                        
                      {/* abre Propuesta de cambio seleccionada */}
                        {swAbrePropuesta &&
                            (<>
                                <div className="margin-1r  background-color-gris3">
                                    {/* encabezado: boton para cerrar  */}
                                    <div className="modal-header text-right mx-1 background-color-gris3 ">
                                        <a id="cierraProp" type="button" onClick={()=>cierraPropuesta()} className=" close">
                                            <i className="mdi mdi-minus-circle-outline text-muted colorGris2  font-size-14"></i>
                                        </a>
                                    </div>
                                    {/* contenido propuesta */}
                                    <div className="jumbotron mx-1 ">
                                        <RDPropuesta
                                            decisionTextoTodos={pfcDetallesFront.decisionTextoTodos} 
                                            indexPropuesta={indexPropuesta}
                                            propuesta = {propuestaDetallesFront}
                                        />
                                        <br/>
                                    </div>
                                </div>
                            </>)
                        }
                    </div>

                {/* Evidencias*/}
                    <div className='margin-top-2r'> 
                      {/* Evidencias de la fase de diseño que serán modificadas por el cambio & art & # evidencias */}
                        <span className="h6 pt-3 ">{eti.contenido[2].text}</span>
                        <span >
                            <button className="btnRT9"  data-tip data-for="articulo9">{eti.contenido[2].text2}</button>
                            <ReactTooltip  id="articulo9" type="info"  place="right" multiline >
                                {articulos.hybridArticles[0].ch} <br/><br/>
                                    Articulo: 9<br /> {articulos.articles[9].description}<br/><br />
                            </ReactTooltip>
                        </span>
                        <span className="circulo pt-1 h5"> {totalEvidencias}</span>
                        <span className="circuloText h5"> {eti.etiquetas[9].text}</span> 
                    
                      {/* panels con evidencias encontradas en pfcDetalles */}
                        <div className="background-color-azul margin-left-1r width-98">
                            {/*     { pfcDetallesStore.evidence?.map((ev:any, indexEv:any) => (     */}
                            { pfcDetallesFront.evidence?.map((ev:any, indexEv:any) => (    
                                (x0 =  `evi_${ev.id}`),
                                /*x2 forma el contendio del header del panel*/
                                (x2 = 
                                   (<>
                                        <div id={x0}>
                                            <span className='h6'> {ev.name} </span>
                                        </div>
                                    </>)
                                ),
                                (<>
                                    <hr />
                                    <PanelGroup accordion className="panelEvd" >
                                        <Panel  
                                            /* eventKey={index} usado cuando se quiere un solo panel abierto */
                                            key={ev.key}
                                            header={x2}
                                            id={ev.id}
                                            collapsible={ev.abierto}
                                            onClick={() => abreCierraEvidenciaDetalles(indexEv, ev)}
                                        >
                                        </Panel>
                                        {ev.abierto
                                            && (<>
                                                <RDEvidencias
                                                    pfcId = {props.pfcId}
                                                    evId = {ev.id}
                                                    miCatPruebas = {ev.miCatPruebas}
                                                    miCatCaracteristicas = {ev.miCatCaracteristicas}
                                                    activaBotonGuardar = {activaBotonGuardar}
                                                    activaBotonEnviar = {activaBotonEnviar}
                                                    desactivaBotonGuardarEnviar = {desactivaBotonGuardarEnviar}
                                                    recargaRDDocumentar = {recargaRDDocumentar}
                                                    recargaRD = {recargaRD}
                                                    recargaPaginaSSC = {recargaPaginaSSC}
                                                    recargaPaginaSSC_Not  = {recargaPaginaSSC_Not }
                                                /> 
                                            </>)  
                                        }
                                    </PanelGroup> 
                                </>)
                            ))}
                            <hr />
                        </div>
                    </div>

                {/* Posible error (combinación de Previstas y No previstas) */}
                    { totalDecision > 1 &&
                      (<>  
                           <label  className="margin-left-1r width-98">
                             <span className="h6 pt-3 color-red small "><i>{eti.mensajes[3].text}</i></span>&nbsp;
                           </label><br />
                      </>)
                    }

                {/* Archivos (cajas dropzone): */}
                    { pfcDetallesStore.misArchivos?.map((ma:any, indexMA:any) => (
                        (x0 =  `articulo10${ma.art}`),
                        (<>
                            { ma.activo &&
                                (<>
                                    <div className='margin-top-2r'> 
                                        <span className="h6 pt-3 ">{ma.descripcion}: </span>
                                        <span>
                                            <button className="btnRT9" data-tip data-for={x0}> (Art. {ma.art} ) </button>
                                            <ReactTooltip  id={x0} type="info"  place="right" multiline >
                                                {articulos.hybridArticles[0].ch} <br/><br/>
                                                 Articulo: {ma.art}<br /> {articulos.articles[ma.art].description}<br/><br />
                                            </ReactTooltip>
                                        </span>
                                    </div> 
                                    <div className="">
                                        <div className="padding-varios ">
                                           {ma.idTipo=='NR'      &&(< NrMyDropzone /> )  } 
                                           {ma.idTipo=='CR'      &&(< CrMyDropzone /> )  } 
                                           {ma.idTipo=='PROOF'   &&(< ProofMyDropzone /> )  } 
                                           {ma.idTipo=='JUSTIFY' &&(< JustifyMyDropzone /> )  } 
                                           {ma.idTipo=='API'     &&(< ApiMyDropzone /> )  } 
                                        </div>
                                    </div>
                                </>)
                            }              
                        </>)
                    ))}    
            </div> 

          <hr />

          {/* pie: Botones */}
            <div id="SlidingPanel_pie">
                <div className='text-right padding-botton-1r'>
                    { pfcDetallesFront.sent == false &&
                        (<>
                            { swBotonGuardarFront  
                                ? <> <button onClick={botonGuardar} className="btn btn-activo">  <span dangerouslySetInnerHTML={{ __html: etiGlobal.botones[2].text, }} ></span></button>&nbsp;</> 
                                : <> <button className="btn btn-inactivo" disabled>  <span dangerouslySetInnerHTML={{ __html: etiGlobal.botones[2].text, }} ></span> </button>&nbsp;</> 
                            }
                            { swBotonEnviarFront 
                                ? <> <button onClick={botonEnviar} className="btn btn-activo"> <span dangerouslySetInnerHTML={{ __html: etiGlobal.botones[3].text, }} ></span> </button>&nbsp;</> 
                                : <> <button className="btn btn-inactivo" disabled> <span dangerouslySetInnerHTML={{ __html: etiGlobal.botones[3].text, }} ></span> </button>&nbsp;</> 
                            }
                        </>)
                    } 
                    <button onClick={botonCerrar}  className="btn btn-sinColor"> <span dangerouslySetInnerHTML={{ __html: etiGlobal.botones[1].text, }} ></span> </button>&nbsp;
                </div>
            </div>

          {/* ventana de carga con spin que se abre mientras lee el api */}
            { cargandoSpin && <CargandoSpin /> }  
      </>
    );
 }


  /* switch(responseAPI.status){
        case 404:  paso.desresul= "El usuario no existe"; break;
        case 401:  paso.desresul= "No autorizado"; break;
        case 404:  paso.desresul= "No tiene información"; break;
        default: paso.desresul= responseAPI.statusText; break;
     } */

